// extracted by mini-css-extract-plugin
export default {"breakdown":"actTotal_breakdown__A4gni","total":"actTotal_total__bCLxt"};